import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Locale from "@/locale";
import DashboardView from "@/views/user/DashboardView.vue";
// import LoginView from "@/views/LoginView.vue";
import ErrorView from "@/views/ErrorView.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    meta: {
      title:"dashboard",
      auth: false,
      passive: false,
    },
    component: DashboardView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: Locale.get("dashboard"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: DashboardView,
  },  
  {
    path: "/:pathMatch(.*)*",
    name: "error",
    meta: {
      title: Locale.get('page.not.found'),
      auth: false,
      passive: true,
    },
    component: ErrorView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  const title = to.meta.title as any;
  document.title = title?.toString();
});

export default router;
